import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'ifarms',
    textName: 'iFarms',
    logo: '/assets/images/logo-2x.png',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=ifarms',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=ifarms',
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
      SM.SM_CHECKS,
      SM.SM_RULE_CHECK,
    ],
    storewebAppUrl:
      'https://www.facebook.com/ifarmsmd/shop/?ref_code=mini_shop_profile_featured_shop_card_cta&ref_surface=profile/',
    forcedDefaultLang: 'ro',
    chatServiceProvider: 'slack',
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    welcomeUserCheck: false,
    store: false,
    enableSloganLogin: false,
  },
  apiBaseUrl: 'https://api.ifarms.md/',
  SSOfrontAppCallback: 'https://app.ifarms.md/#/oauthCheck?token=',
  launchDarklyKey: '67603edfa30d7b094c8d3782',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/ifarms/',
  palette: {
    '--p-xFarm-xColor-50': '#dee8de',
    '--p-xFarm-xColor-100': '#bed1be',
    '--p-xFarm-xColor-200': '#9eba9f',
    '--p-xFarm-xColor-300': '#7fa480',
    '--p-xFarm-xColor-400': '#608e63',
    '--p-xFarm-xColor-500': '#567f59',
    '--p-xFarm-xColor-600': '#4d704f',
    '--p-xFarm-xColor-700': '#446145',
    '--p-xFarm-xColor-800': '#3b533c',
    '--p-xFarm-xColor-900': '#324633',
    '--p-xFarm-xColor-950': '#29382a',
  },
  primaryOpacity: '#608e63',
  primaryOpacity15: '#608e6326',
};
